import { i18n } from '@/plugins/i18n'

const fields = [
    {
        key: 'id',
        label: i18n.t('invoice.id'),
        _classes: "text-center",
        _style: "width: 5%"
    },
    {
        key: 'user',
        label: i18n.t('user.full_name'),
        _classes: "text-center",
        _style: "width: 15%"
    },
    {
        key: 'amount',
        label: i18n.t('invoice.amount')+' ('+i18n.t('rial')+')',
        _classes: "text-center",
        _style: "width: 25%"
    },
    {
        key: 'startedAt',
        label: i18n.t('invoice.started_at'),
        _classes: "text-center",
        _style: "width: 10%"
    },
    {
        key: 'finishedAt',
        label: i18n.t('invoice.finished_at'),
        _classes: "text-center",
        _style: "width: 10%"
    },
    {
        key: 'status',
        label: i18n.t('invoice.status'),
        _classes: "text-center",
        _style: "width: 20%"
    },
    {
        key: 'actions',
        label: i18n.t('actions'),
        _style: 'width:15%;',
        _classes: 'text-center align-middle'
    }
]

export default fields

export const sorts = [
    {
        label: i18n.t('sorter.desc', { attr: i18n.t('invoice.id') }),
        value: {
            direction: 'desc',
            column: 'id'
        }
    },
    {
        label: i18n.t('sorter.asc', { attr: i18n.t('invoice.id') }),
        value: {
            direction: 'asc',
            column: 'id'
        }
    }
]